export default __webpack_public_path__ + "static/media/dog-02.b053daf2.jpg";